import { Button, Select } from 'antd';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import useStatsStore from 'modules/engagement_report/engagement_stats/store';
import { FilterOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useCategoryData, useTicketGroups } from 'pages/store';
import React, { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { formatDate } from 'modules/utilities/utility';
import DatePicker from "react-datepicker";


const DashboardFilter = ({ selectedSubcat, setSelectedSubcat, userData, setUserData, startDate, setStartDate, endDate, setEndDate }) => {
    const [subcategoryMap, setSubcategoryMap] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const { fetchTicketDashboardData } = useTicketGroups();
    const { users, fetchUserData } = useStatsStore();
    const { fetchCategoryData, categorySubcatData } = useCategoryData();

    useEffect(() => {
        fetchUserData();
        fetchCategoryData();
    }, []);

    useEffect(() => {
        const options = users.map((user) => {
            return {
                value: user.user.first_name + '|' + user.user_id + '|' + user.user.email,
                label: `${user.user.first_name} (${user.user.email})`,
            }
        })
        setUserOptions(options)
    }, [users])

    useEffect(() => {
        const subcategories = _.get(categorySubcatData, ['data', 'subcategory'], []);
        let subcategoryKeys = [];
        for (const subcategory of Object.values(subcategories)) {
            const keys = subcategory.map((subcat) => { return { value: subcat.key, label: subcat.label } }).filter(subcat => ![...subcategoryKeys.map(_subcat => _subcat.value)].includes(subcat.value))
            subcategoryKeys.push(...keys);
        }

        setSubcategoryMap(subcategoryKeys);
    }, [categorySubcatData])

    const handleSelect = (value) => {
        const data = value.map((userId) => {
            return userId.split('|')[1]
        })
        setUserData(data);
    }

    const getMaxDate = (date) => {
        if (!date) return null;
        const maxDate = new Date(date);
        maxDate.setDate(maxDate.getDate() + 30);

        const today = new Date();
        if (maxDate > today) {
            return today;
        } else {
            return maxDate;
        }
    };

    const getMinDate = (date) => {
        if (!date) return null;
        const minDate = new Date(date);
        minDate.setDate(minDate.getDate() - 30);
        return minDate;
    };
    const [open, setOpen] = useState(false);
    return (
        <div className='d-flex justify-content-end py-3'>
            <Button type="primary" className='d-flex align-items-center' onClick={() => { setOpen(true); }}>
                <FilterOutlined /> Filter
            </Button>
            <Offcanvas show={open} onHide={() => setOpen(false)} placement={'end'} style={{ width: '35%' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filter Dashboard</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                    <div className='d-flex justify-content-between  align-items-center gap-2'>

                        <strong style={{ width: '15%' }}>Subcategory</strong>
                        <Select
                            style={{ width: '85%', flex: 3, margin: '5px 0' }}
                            mode="multiple"
                            onSelect={(option) => {
                                setSelectedSubcat((prevSelectedSubcat) => [...prevSelectedSubcat, option]);
                            }}
                            showSearch
                            allowClear
                            placeholder="Search/Select Subcategory"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={subcategoryMap}
                        />
                    </div>

                    <div className='d-flex justify-content-between  align-items-center gap-2'>
                        <strong style={{ width: '15%' }}>User</strong>
                        <Select
                            style={{ width: '85%', flex: 3, margin: '5px 0' }}
                            mode="multiple"
                            placeholder="Please select"
                            onChange={handleSelect}
                            options={userOptions}
                            allowClear
                            virtual={false}
                        />
                    </div>

                    <div className='d-flex justify-content-between  align-items-center gap-4 my-2'>
                        <strong style={{ width: '15%' }}>Start Date</strong>
                        <DatePicker
                            selected={startDate}
                            onChange={date => setStartDate(date)}
                            placeholderText="Start Date"
                            dateFormat="dd-MM-yyyy"
                            value={startDate ? formatDate(startDate) : ""}
                            className="form-control"
                            minDate={getMinDate(endDate)}
                            maxDate={endDate}
                        />
                    </div>

                    <div className='d-flex justify-content-between  align-items-center gap-4 my-2'>

                        <strong style={{ width: '15%' }}>End Date</strong>
                        <DatePicker
                            className='form-control'
                            selected={endDate}
                            onChange={date => setEndDate(date)}
                            placeholderText="End Date"
                            dateFormat="dd-MM-yyyy"
                            maxDate={getMaxDate(startDate)}
                            minDate={new Date(endDate.getTime() - 30 * 24 * 60 * 60 * 1000)}
                            value={endDate ? formatDate(endDate) : ""}
                        />
                    </div>
                    <div className='d-flex justify-content-between gap-2'>

                        <Button type="primary"
                            className='flex-1'
                            disabled={!(startDate && endDate)}
                            onClick={() => {
                                fetchTicketDashboardData({
                                    startDate: moment(startDate).startOf('day').toISOString(),
                                    endDate: moment(endDate).endOf('day').toISOString(),
                                    subCategory: selectedSubcat,
                                    user: userData,
                                })
                                setOpen(false)
                            }}>Submit</Button>
                        <Button
                            className='flex-1'
                            onClick={() => { setOpen(false) }}
                        >
                            Close
                        </Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

        </div>
    )
}

export default DashboardFilter;